/* eslint-disable react/prop-types */
import React from 'react';
import Modal from '@mui/material/Modal';
import { Typography, CardContent } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Unstable_Grid2';
import Button from '@mui/material/Button';
import { IoNewspaperOutline, IoCloseOutline, IoInformationCircleOutline } from 'react-icons/io5';

const NewsNotify = ({ isOpen, closeModal, news }) => {
    const snippet = news?.plain_text_body
        ? typeof news.plain_text_body === 'string'
            ? news.plain_text_body.replace(/<[^>]+>/g, '').substring(0, 250)
            : ''
        : '';

    function handleView() {
        closeModal(true);
        window.location.replace('/news-events/news?activeTab=news');
    }

    return (
        <Modal
            keepMounted
            open={isOpen}
            onClose={() => closeModal(true)}
            aria-labelledby="news-notify-modal-title"
            aria-describedby="news-notify-modal-description"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(0, 0, 0, 0.4)'
            }}
        >
            <Box
                sx={{
                    width: { xs: '90vw', sm: '80vw', md: '500px' },
                    maxWidth: '500px',
                    outline: 'none'
                }}
            >
                <Card
                    sx={{
                        borderRadius: '20px',
                        border: 'none',
                        boxShadow: 'none',
                        backgroundColor: '#ffffff',
                        overflow: 'hidden',
                        position: 'relative'
                    }}
                >
                    <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}>
                        <Button
                            onClick={() => closeModal(true)}
                            sx={{
                                minWidth: 'auto',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                color: '#666',
                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.1)', transform: 'scale(1.05)' },
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <IoCloseOutline size={20} />
                        </Button>
                    </Box>

                    <CardContent sx={{ padding: '40px 32px' }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Box
                                    sx={{
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '50%',
                                        backgroundColor: 'rgba(30, 124, 136, 0.1)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: 2
                                    }}
                                >
                                    <IoNewspaperOutline size={36} color="#1E7C88" />
                                </Box>
                            </Grid>

                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Typography variant="h5" sx={{ fontWeight: 600, color: '#1a1a1a', textAlign: 'center', marginBottom: 1 }}>
                                    New News
                                </Typography>
                            </Grid>

                            {snippet && (
                                <Grid item xs={12} display="flex" justifyContent="center">
                                    <Typography sx={{ color: '#666', textAlign: 'center', lineHeight: 1.6, fontSize: '14px' }}>
                                        {snippet}
                                        {snippet.length >= 250 ? '...' : ''}
                                    </Typography>
                                </Grid>
                            )}

                            <Grid item xs={12} sx={{ marginTop: 3 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        gap: 2,
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        alignItems: { xs: 'stretch', sm: 'center' }
                                    }}
                                >
                                    <Button
                                        variant="outlined"
                                        onClick={() => closeModal(true)}
                                        sx={{
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                            padding: '8px 16px',
                                            borderColor: '#e0e0e0',
                                            color: '#666',
                                            backgroundColor: 'transparent',
                                            boxShadow: 'none',
                                            minWidth: '100px'
                                        }}
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleView}
                                        startIcon={<IoInformationCircleOutline />}
                                        sx={{
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                            padding: '8px 16px',
                                            backgroundColor: '#1E7C88',
                                            boxShadow: 'none',
                                            minWidth: '140px'
                                        }}
                                    >
                                        View
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Modal>
    );
};

export default NewsNotify;
